<ion-header>
  <ion-toolbar>
    <ion-title>{{'PROFILE' | translate}}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <span ion-text color="primary" when="ios">Cancel</span>
        <ion-icon name="close" showWhen="android, windows"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar>
    <ion-searchbar (ionInput)="searchbarInput($event)"></ion-searchbar>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-list id="modal-list">
    <ion-item *ngFor="let item of filteredItems; trackBy: trackItems" lines="none">
      <ion-label>{{ item.label }}</ion-label>
      <ion-checkbox slot="start" [value]="item.code"
        [checked]="isChecked(item.code)" (ionChange)="checkboxChange($event)"
      ></ion-checkbox>
    </ion-item>
  </ion-list>
</ion-content>

<ion-footer>
    <ion-button expand="block" [disabled]="cantValidate" color="primary" type="submit" (click)="save()">
      {{'VALIDATE' | translate}}
    </ion-button>
  </ion-footer>